module.exports = __webpack_public_path__ + "img/cart-plus.92c2af98.svg";